import L from 'leaflet'
import type { MyMap } from '@map-sdk/sdk/ShipxyAPISDK'

/**
 * 潮汐弹出窗口
 */
export class TidesPopupWindow {
  map: MyMap
  container: HTMLDivElement
  constructor(map: MyMap) {
    this.map = map
    const html = `<div class="tbody" id="tbodymove">
                  <tr>20 <td class="tide_hm ">20
                      <div id="tide_title" class="tide_title">潮汐观测点: 大戢山 (浙江 舟山市)</div>
                      20 <a href="javascript:void(0);" id="tide_close" class="tide_close">
                      </a>20 </td>
                  </tr>
                  <tr>20 <td id="tide_mm">20
                      <div class="tide_body" style="">2020<div>2020
                          <div id="tide_loading" style="height: 428px; display: none;">
                            202020 <div style="padding-top:200px;text-align:center;color:gray;">
                              加载中，请稍后...
                            </div>2020</div>2020<div id="tide_content" class="tide_content">202020
                            <a class="tide_a before"> 前一天</a>
                            <a class="tide_a after">后一天</a>
                            <div id="box_tide_day" class="tide_day_box">
                              <table class="tide-table">
                                <tbody>
                                  <tr>
                                    <td id="tide_day_1" class="tide_day_title border-left"
                                      width="50%">
                                      2018年01月25日 (腊月 初九)</td>
                                    <td id="tide_day_2" class="tide_day_title td-next">2018年01月26日
                                      (腊月 初十)</td>
                                  </tr>
                    <td class="border-left">
                      <table class="tide_day_table">
                        <tbody id="tide_day_table1">
                          <tr>
                            <td>潮时一</td>202020202020<td width="70">03:34</td>202020202020
                            <td>潮高：</td>202020202020<td width="50" align="left">343cm</td>
                            202020202020
                          </tr>202020202020<tr>202020202020<td>潮时二：</td>202020202020<td>09:52</td>
                            202020202020<td>潮高：</td>
                            <td align="left">143cm</td>
                          </tr>
                          <tr>
                            <td>潮时三：</td>202020202020<td>15:46</td>202020202020<td>潮高：</td>
                            <td align="left">347cm</td>
                          </tr>
                          <tr>
                            <td>潮时四：</td>
                            <td>22:36</td>
                            <td>潮高：</td>
                            <td align="left">112cm</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                    <td class="td-next">
                      <table class="tide_day_table">
                        <tbody id="tide_day_table2">
                          <tr>
                            <td>潮时一：</td>
                            <td width="70">04:51</td>
                            <td>潮高：</td>
                            <td width="50" align="left">337cm</td>
                          </tr>
                          <tr>
                            <td>潮时二：</td>
                            <td>11:15</td>
                            <td>潮高：</td>
                            <td align="left">164cm</td>
                          </tr>
                          <tr>
                            <td>潮时三：</td>
                            <td>17:04</td>
                            <td>潮高：</td>
                            <td align="left">322cm</td>
                          </tr>
                    <td>潮时四：</td>
                    <td>23:54</td>
                    <td>潮高：</td>
                    <td align="left">116cm</td>
                  </tr>
                  </tbody>
                  </table>
                  </td>
                  </tr>
                  </tbody>
                  </table>
                </div>
                <div id="tide_img" class="tide_img">
                  <div id="tide_echart_div" class="tide_echart_div"> </div>
                </div>
                </div>
                </div>
                <!--<div class="xwin_full xwin_alpha" style="height: 430px; display: none;"></div>-->
                </div>
                </td>
                <!--<td class="xwin_mr xwin_e_e"></td>-->
                </tr>
                </div>`
    this.container = document.createElement('div') as HTMLDivElement
    this.container.innerHTML = html
  }

  show() {
    L.DomEvent.disableClickPropagation(this.container)
    this.map.getContainer().appendChild(this.container as any)
    // const img = document.getElementsByTagName('img') as HTMLElement
    // img.ondragstart = function () {
    //   return false
    // }
    const tbodymove = document.querySelector('#tbodymove') as HTMLElement
    tbodymove.onmousedown = (e) => {
      const offsetLeft = e.clientX - tbodymove.offsetLeft
      const offsetTop = e.clientY - tbodymove.offsetTop
      document.onmousemove = (e) => {
        let left = e.clientX - offsetLeft
        let top = e.clientY - offsetTop
        const size = this.map.getSize()
        left <= 0 ? (left = 0) : left >= size.x - 600 && (left = size.x - 600),
          top <= 0 ? (top = 0) : top >= size.y - 430 && (top = size.y - 430),
          (tbodymove.style.left = `${left}px`),
          (tbodymove.style.top = `${top}px`)
      }
      document.onmouseup = function () {
        document.onmousemove = null
        document.onmouseup = null
      }
    }
  }
}
